<template>
  <v-container class="mt-5 ml-2" fluid v-if="getEscuela == 1 || accesos.includes( getdatosUsuarioERPERP.iderp ) || [12,'12'].includes(getdatosUsuarioERPERP.idpuesto)">
    <!-- v-if="usuariosAcceso.includes( getdatosUsuarioERPERP.iderp ) || accesos.includes( getdatosUsuarioERPERP.iderp ) " -->
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            Reporte al momento INBI
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              @click="initialize4()"
              small
              tile
            >
              Consultar
            </v-btn>

            <!-- <v-btn
              color="primary"
              @click="crearGrafica()"
              small
              tile
            >
              Consultar 2
            </v-btn> -->
          </v-card-title>

          <v-card-text>

            <!-- Titulo de las ventas diarias por escuela -->
          	<v-row>
          		<v-col cols="12" md="6">
		            <v-row>
		            	<v-col cols="12" md="6" lg="6"  v-if="ciclo && resumenInbiCiclo">
                    <v-card color="shadowCard text-center">

                      <v-card-title primary-title v-if="ciclo">
                        <v-spacer></v-spacer>
                        <div>{{ ciclo }}</div>
                        <v-spacer></v-spacer>
                      </v-card-title>

                      <v-card-title primary-title>
                        <v-spacer></v-spacer>
                        <div>Inscritos por ciclo
                          <!-- <v-card color="#BD0014" dark class="pa-4 text-center text-h3 shadowCard" @click="tablaVentasCiclo = tablaFast, dialogVentasCiclo = true ">
                            {{ totalFast }}
                          </v-card> -->
                        </div>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-card-text>
                        <v-progress-circular
                          :rotate="90"
                          :size="160"
                          :width="15"
                          :value="resumenInbiCiclo.porcentaje"
                          color="blue"
                        >
                          <div class="text-h3"><b>{{ resumenInbiCiclo.total }}</b></div>
                        </v-progress-circular>
                        <v-row class="align-center mt-4 text-h6">
                          <v-col cols="6">
                            <div>NI {{ ciclo }}</div>
                            <div>{{ resumenInbiCiclo.meta }}</div>
                          </v-col>

                          <v-col cols="6">
                            <div>Faltan</div>
                            <div> {{ resumenInbiCiclo.faltan }} </div>
                          </v-col>
                          <v-col cols="12" class="grey--text text-subtitle-1">Cambios: {{ ventasCambiosInbi }}</v-col>
                        </v-row>

                      </v-card-text>

		            		</v-card>
		            	</v-col>

                  <v-col cols="12" md="6" lg="6"  v-if="ciclo">
                    <TarjetaTiempoActividad
                      :nombre="nombreEfectividad"
                      :hora-inicio="primer_contacto"
                      :tiempo-actividad="tiempoActividad"
                    />
                  </v-col>

		            </v-row>
          		</v-col>


          		<v-col cols="12" md="6">
                <PanelResumenSemana
                  v-if="encabezados"
                  :fecha-inicio="encabezados.fecha_inicio_format"
                  :fecha-fin="encabezados.fecha_final_format"
                  etiqueta="Nvas. Liq. INBI"
                  :semana-ant="encabezados && encabezados.matriculas_liquidadasSemAnt"
                  :semana-act="encabezados && encabezados.matriculas_liquidadas"
                  @click-semana-act="abrirVentasSemanaInbi"
                >
                  <template #footer>
                    <TarjetaDiasInscripcion
                      embebida
                      :fecha-inicio="formatFecha(segundaSemanaCicloActual)"
                      :fecha-fin="formatFecha(segundoDomingoCicloProximo)"
                      :dias="diasFaltantes(segundoDomingoCicloProximo)"
                    />
                  </template>
                </PanelResumenSemana>
          		</v-col>
          	</v-row>

            <v-row>
              <v-col cols="12">
                <v-card class="shadowCard">
                  <v-card-title primary-title class="text-subtitle-1">
                    Inscritos Inbi
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headersNiSucursal"
                      :items="dataTablaInbiUno"
                      class="elevation-0"
                      hide-default-footer
                      :items-per-page="dataTablaInbiUno.length"
                      dense
                      mobile-breakpoint="200"
                    >
                        <template v-slot:no-data>
                          <v-btn
                            color="primary"
                            @click="initialize4"
                            small
                          >
                            Actualizar
                          </v-btn>
                        </template>

                        <template v-slot:item.porcentajeConvencimiento="{ item }">
                          {{ calcularConvencimiento(item.total, item.totalContactos) }}%
                        </template>

                        <template v-slot:item.total="{ item }">
                          <v-chip
                             color="blue" text-color="white" small>
                            {{ item.total }}
                          </v-chip>
                          <!-- @click="verQuienVendio(item.quienVendio, item)" -->
                        </template>

                        <template v-slot:item.totalContactos="{ item }">
                          <v-chip 
                          color="red" text-color="white" small>
                            {{ item.totalContactos }}
                          </v-chip>
                          <!-- @click="verDetalle(item.prospectos, item.vendedoras)" -->
                        </template>

                        <template v-slot:item.total_completos="{ item }">
                          <v-chip 
                          color="grey" text-color="white" small>
                            {{ item.total_completos - item.total_incompletos }}
                          </v-chip>
                          <!-- @click="verDetalle(item.completos)" -->
                        </template>

                        <template v-slot:item.total_incompleto="{ item }">
                          <v-chip 
                          color="grey" text-color="white" small>
                            {{  item.total_incompletos }}
                          </v-chip>
                          <!-- @click="verDetalle(item.incompletos)" -->
                        </template>

                        <template v-slot:item.total_merca="{ item }">
                          <v-chip
                          color="purple" text-color="white" small>
                            {{  item.total_merca }}
                          </v-chip>
                          <!-- @click="verDetalle(item.merca, item.vendedorasMerca)" -->
                        </template>

                        <template v-slot:item.total_sucursal="{ item }">
                          <v-chip
                          color="purple" text-color="white" small>
                            {{  item.total_sucursal }}
                          </v-chip>
                          <!-- @click="verDetalle(item.sucursal, item.vendedorasSucursal)" -->
                        </template>

                      </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Mostrar los alumnos -->
    <v-dialog
      v-model="dialogAlumnos"
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="1200"
    >
      <v-card>
        <v-card-title primary-title>
          Alumnos
          <v-spacer></v-spacer>

          <v-btn
            class="mr-10"
            small
            dark
            color="green"
            tile
          >
            <!-- @click="exportarAlumnos( alumnos , 'ALUMNOS_NI' )" -->
            <!-- v-if="![18,40,19,17,53,52,57].includes( getdatosUsuarioERPERP.idpuesto )" -->
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnos"
            :items="alumnos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="dialogAlumnos = false"
            small
            absolute
            top
            right
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogVentasCiclo"
      max-width="1000px"
    >
      <v-card>
      	<v-card-title primary-title class="text-subtitle-1">
      	  Ventas por ciclo por vendedora
      	</v-card-title>
        <v-card-text>

          <v-select
            v-model="inbiFilter"
            :items="ciudad"
            @change="onCiudadChangeVentasCicloVendedora"
            label="Filtrar por ciudad"
            dense
            outlined
          ></v-select>

	      	<v-data-table
            :headers="headers"
            :items="tablaVentasCiclo"
            item-key="vendedora"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            :items-per-page="tablaVentasCiclo.length"
            hide-default-footer
          >
            <template v-slot:item.completos="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.completosA )"
              >
                {{ item.completos }}
              </v-chip>
            </template>

            <template v-slot:item.ventasAyer="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.ventasAyerDetalle )"
              >
                {{ item.ventasAyer }}
              </v-chip>
            </template>

            <template v-slot:item.ventasAntier="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.ventasAntierDetalle )"
              >
                {{ item.ventasAntier }}
              </v-chip>
            </template>


            <template v-slot:item.tendencia="{ item }">

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 2"><v-icon color="green"  small>mdi-arrow-up-bold</v-icon><b>{{ item.diferencia }}</b></span>
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 3"><v-icon color="red"    small>mdi-arrow-down-thick</v-icon><b>{{ item.diferencia }}</b></span>
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 1"><v-icon color="orange" small>mdi-equal</v-icon><b>{{ item.diferencia }}</b></span>
                </template>
                <span>( {{ item.ventasAyer }} (ayer) - {{ item.ventasAntier }}( antier ) ) </span>
              </v-tooltip>

            </template>

          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="tablaVentasCiclo = [], dialogVentasCiclo = false">
          	Cancelar
          </v-btn>

          <v-btn icon color="black" top right absolute @click="tablaVentasCiclo = [], dialogVentasCiclo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogVendedorasSemana"
      max-width="600px"
    >
      <v-card>
      	<v-card-title primary-title class="text-subtitle-1">
      	 	{{ tituloSemana }}
      	</v-card-title>
        <v-card-text>
          <v-select
            v-model="inbiFilter"
            :items="ciudad"
            label="Filtrar por ciudad"
            dense
            outlined
          ></v-select>
	      	<v-data-table
	          :headers="headers2"
	          :items="dataTablaSemanaFiltered"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	          hide-default-footer
	          :items-per-page="dataTablaSemana.length"
	        >

            <template v-slot:item.matriculas_liquidadas="{ item }">
              <v-chip
                small
                color="primary"
                @click="alumnosSeleccion = item.nuevasMatriculas, dialogAlumnosSeleccion = true"
              >
                {{ item.matriculas_liquidadas }}
              </v-chip>
            </template>

	        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogVendedorasSemana = false">
          	Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogAlumnosSeleccion"
      max-width="1200px"
    >
      <v-card>
        <v-card-title primary-title class="text-subtitle-1">
          Alumnos inscritos
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumno"
            :items="alumnosSeleccion"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            hide-default-footer
            :items-per-page="alumnosSeleccion.length"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogAlumnosSeleccion = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Inscritos Prospectos -->
    <v-dialog
      v-model="dialogInscritosProspectos"
      max-width="1200px"
    >
      <v-card >
        <v-card-title primary-title class="text-subtitle-1">
          Prospectos Inscritos
        </v-card-title>
        <v-card-text>
          <v-card v-if="vendedoras.length" class="py-4 mb-6">
            <v-card-title>
              📊 Prospectos asignados a vendedoras
            </v-card-title>

            <v-card-subtitle>
              Resumen de contactos asignados en el período seleccionado
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-list >
              <v-list-item
                v-for="v in vendedoras"
                :key="v.usuario_asignado"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ v.nombre_completo || 'Sin nombre' }}
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    ID: {{ v.usuario_asignado }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-chip color="primary" outlined>
                    {{ v.total_contactos }} prospectos
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
          <v-data-table

            :headers="headersProspectos"
            :items="prospectosInscritos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            hide-default-footer
            :items-per-page="prospectosInscritos.length"
          >
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogInscritosProspectos = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Quien vendio -->
    <!-- Quien vendio -->
    <v-dialog
      v-model="dialogQuienVendio"
      max-width="1200px"
    >
      <v-card v-if="itemSucursal">
        <v-card-title primary-title class="text-subtitle-1">
          Distribución de ventas
        </v-card-title>
        <v-card-text>

          <div class="black--text text-h6">
            Meta {{ itemSucursal.plantel }} : {{ itemSucursal.meta }}</br>  
            Llevas: {{ itemSucursal.total }}  </br>
          </div>

          </br>
          
          <v-data-table
            :headers="headersQuienVendio"
            :items="quienVendio"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            hide-default-footer
            :items-per-page="quienVendio.length"
          >
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogQuienVendio = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>

  import Chart from 'chart.js/auto';

  import axios from 'axios';

  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import TarjetaTiempoActividad from '@/components/kpi/TarjetaTiempoActividad.vue'
  import TarjetaDiasInscripcion from '@/components/kpi/TarjetaDiasInscripcion.vue'
  import PanelResumenSemana from '@/components/kpi/PanelResumenSemana.vue'

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import * as am5 from '@amcharts/amcharts5';
  import * as am5xy from '@amcharts/amcharts5/xy';
  import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

  export default {

    components:{
      Alerta,
      carga,
      TarjetaTiempoActividad,
      TarjetaDiasInscripcion,
      PanelResumenSemana,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialogAlumnos:false,

      headers: [
        { text: 'Position'     , value: 'position'     },
        { text: 'Vendedora'    , value: 'vendedora'    },
        { text: 'Puesto'       , value: 'puesto'       },
        { text: 'Plantel'      , value: 'plantel'      },
        { text: 'Ciudad'       , value: 'estado'       },
        { text: 'I completo'   , value: 'completos'    },
        { text: 'I Antier'     , value: 'ventasAntier' },
        { text: 'I Ayer'       , value: 'ventasAyer'   },
        { text: 'Tendencia'    , value: 'tendencia'    },
      ],

      headersProspectos: [
        { text: '#', value: 'index', sortable: false },
        { text: 'id prospectos'    , value: 'idprospectos'    },
        { text: 'nombre completo'    , value: 'nombre_completo'    },
        { text: 'correo'    , value: 'correo'    },
        { text: 'telefono'    , value: 'telefono'    },
        { text: 'twilio'    , value: 'twilio'    },
        { text: 'fecha_creacion'    , value: 'fecha_creacion'    },
        { text: 'fecha_finalizo'    , value: 'fecha_finalizo'    },
        { text: 'nota_inicial'    , value: 'nota_inicial'    },
        { text: 'nota_rechazo'    , value: 'nota_rechazo'    },
      ],
      headersQuienVendio: [
        { text: '#', value: 'index', sortable: false },
        { text: 'id usuario'       , value: 'id_usuario'  },
        { text: 'nombre completo'  , value: 'nombre_completo'   },
        { text: 'total'            , value: 'total_registros'   },
        { text: 'Porcentaje'       , value: 'porcentaje'        },
      ],
      prospectosInscritos: [],
      vendedoras: [],
      quienVendio: [],
      dialogInscritosProspectos: false,
      dialogQuienVendio: false,

      headersMiniReporte: [
        { text: 'Escuela'        , value: 'escuela'  },
        { text: 'Monto 1'        , value: 'monto1'  },
        { text: 'Sucursal NI'    , value: 'sucursalni'  },
        { text: 'RI Total'       , value: 'ritotal'  },
        { text: 'RI Sucursal'    , value: 'risucursal'  },
        { text: 'Diferencia Suc' , value: 'dif'  },
      ],

      headersNiSucursal: [
        { text: 'Sucursal'            , value: 'plantel'  },
        { text: 'Total Contactos'     , value: 'totalContactos'  },
        { text: 'Total Incompletos'   , value: 'total_incompleto'  },
        { text: 'Total Completos'     , value: 'total_completos'  },
        { text: 'Total Sucursal'      , value: 'total_sucursal'  },
        { text: 'Total Merca'         , value: 'total_merca'  },
        { text: 'Meta'                , value: 'meta'     },
        { text: 'Total'               , value: 'total'    },
        { text: 'Faltan'              , value: 'faltan'   },
        { text: '% convencimiento'    , value: 'porcentajeConvencimiento'   },
      ],

      tiempoActividad: '',

      headersAlumno: [
        { text: 'id Prospecto'   , value: 'id_prospecto'  },
        { text: 'Matricula'      , value: 'matricula'     },
        { text: 'Alumno'         , value: 'alumno'        },
        { text: 'Grupo'          , value: 'grupo'         },
        { text: 'Fecha Alta'     , value: 'fecha_alta'    },
        { text: 'Fecha pago'     , value: 'fecha_pago'    },
        { text: 'Pagado'         , value: 'pagado'        },
        { text: 'Adeudo'         , value: 'adeudo'        },
      ],

      alumnosSeleccion: [],
      dialogAlumnosSeleccion: false,

      dataTablaFastUno:[],
      dataTablaInbiUno:[],
      dataTablaFastDos:[],

      desserts: [],

      tablaFast:[],
      tablaInbi:[],

      fechaini:null,
      fechafin:null,
      totalInbi:0,
      totalFast:0,

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      headers2: [
        { text: 'Vendedora'       , value: 'nombre_completo'       },
        { text: 'T. Contactos'    , value: 'total_contactos'       },
        { text: 'Mat. Nvas. Liq.' , value: 'matriculas_liquidadas' },
        { text: 'Convencimiento'  , value: 'porcentaje' },
        { text: 'Ciudad' , value: 'estado' },
      ],

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      nuevasMatriculas:[],
      vendedorasActuales:[],
      vendedorasActualesFiltered:[],
      encabezados: null,
      encabezados_ant: null,
      escuela: 1,

      headers5: [
        { text: 'Matriculas' , value: 'columna1', width: '40%', align: 'start' },
        { text: 'Semana Ant' , value: 'columna2', width: '35%', align: 'start' },
        { text: 'Semana Act' , value: 'columna3', width: '35%', align: 'start' },
      ],
      datosTablaHeaders5:[],
      datosTablaHeaders6:[],
      vendedorasActualesFAST:[],
      vendedorasActualesFASTFiltered:[],
      encabezadosFast: null,
			encabezados_antFast: null,

      miniReporte:[],

			reporteFast:[],
			reporteInbi:[],

      headersRI: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Plantel'          , value: 'plantel' },
        { text: 'Estado'          , value: 'estado' },
        //{ text: 'Acumulado'        , value: 'acumuladoant' },
        //{ text: 'Becados'          , value: 'becadosant' },
        //{ text: 'NI'               , value: 'niant' },
        //{ text: 'Rezagados'        , value: 'resagados' },

        //{ text: 'A. Ciclo Actual'  , value: 'totalAlumnosActuales' },
        //{ text: 'A. Irregulares'   , value: 'irregulares' },
        //{ text: 'Becados'          , value: 'becados' },
        //{ text: 'B. Certificacion' , value: 'becadoCertificacion' },
        //{ text: 'Certificacion'    , value: 'certificacion' },
        //{ text: 'Reinscribibles'   , value: 'reinscribibles' },
        //{ text: 'Acumulado'        , value: 'totalAlumnosSiguientes' },
        //{ text: 'Avance'           , value: 'totalAlumnosAyer' },
        //{ text: 'Faltantes'        , value: 'faltantes', class: 'columna2' },
        { text: '%RI'              , value: 'porcentajeAvance' },
        //{ text: 'META'             , value: 'meta_alumnos' },
        //{ text: 'META NI'          , value: 'meta_ni' },
      ],

      headersCerrados: [
			  { text: 'Vendedora',    value: 'nombre_completo' },
        { text: 'Atrasados',    value: 'atrasados'       },
			  { text: 'Nuevos',       value: 'nuevos'          },
			  { text: 'Seguimiento',  value: 'seguimiento'     },
			  { text: 'Total',        value: 'total'           },
			  { text: 'Contactos',    value: 'contactos'       },
      ],

      headersAlumnos: [
        { text: 'Matricula',    value: 'matricula'  },
        { text: 'Alumno'   ,    value: 'alumno'     },
        { text: 'Grupo'    ,    value: 'grupo'      },
        { text: 'Plantel'  ,    value: 'plantel'    },
      ],

      fecha_inicio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fecha_final:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      ciclo: null,

      resultadoRi: [],
      resultadoRiFiltro: [],

      tablaVentasCiclo:[],
      tablaVentaCicloInbi : false,
      dialogVentasCiclo: false,

      dialogVendedorasSemana: false,
			dataTablaSemana:  [],
			tituloSemana: '',

      fast: null,
      inbi: null,
      alumnos:[],

      id_ciclo: null,
      id_ciclo_relacionado: null,

      grafica_data: [],

      root: null,

      inbiFilter: '',
      ciudad: [
        { text: 'Todos', value: null },
        { text: 'Monterrey', value: 1 },
        { text: 'CDMX', value: 2 },
        { text: 'GDL', value: 3 },
        { text: 'FAST', value: 4 }
      ],

      metas: [],
      segundaSemanaCicloActual: '',
      segundoDomingoCicloProximo: '',
      restanDias: null,
      itemSucursal: null,
      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      vendedoras: [],
      primer_contacto: null,
      accesos: [1,334,568,3042],
      nombreEfectividad: '',
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      ventasCambiosInbi(){
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total_fuera_ciclo || 0
        }
        return 0
      },

      resumenInbiCiclo() {
        const rows = this.dataTablaInbiUno || []
        if (!rows.length) return null
        const last = rows[rows.length - 1] || {}
        const total = Number(last.total) || 0
        const meta = Number(last.meta) || 0
        const faltan = last.faltan != null ? last.faltan : Math.max(meta - total, 0)
        const porcentaje = meta > 0 ? (total / meta) * 100 : 0
        return { total, meta, faltan, porcentaje }
      },

      dataTablaSemanaFiltered() {

        if( this.dataTablaSemana.length ) {
          const r = this.traducirEstado( this.inbiFilter )

          this.dataTablaSemanaFiltered = this.dataTablaSemana
          if(r) {
            //this.dataTablaSemanaFiltered
            //this.dataTablaSemanaFiltered = [...this.dataTablaSemanaFiltered, this.calcularTotal(this.dataTablaSemanaFiltered)];
            //console.log( this.dataTablaSemana.filter(item => item.estado === r) )
            return this.dataTablaSemana.filter(item => item.estado === r);
          }
          else {
            return this.dataTablaSemana
          }
        }

      }
    },

    async created () {
      await this.initialize4()
    },

    mounted( ){
      if (!this.$refs.myChart) return
      const ctx      = this.$refs.myChart.getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Sofía', 'Ana', 'Luisa', 'Karla', 'Diana'],
          datasets: [{
            label: 'Ventas',
            data: [12, 19, 7, 14, 10],
            backgroundColor: [
              '#FF6384',
              '#36A2EB',
              '#FFCE56',
              '#4BC0C0',
              '#9966FF'
            ],
            borderRadius: 10
          }]
        },
        options: {
          animation: {
            duration: 1500,
            easing: 'easeOutBounce'
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: (ctx) => `🎯 ${ctx.dataset.label}: ${ctx.formattedValue} ventas`
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return value + ' 🛍️';
                }
              }
            }
          }
        }
      });

    },

    watch:{
      dataTablaSemana( value ){
        console.log('watch')
        console.log( value )
      }
    },

    methods: {

      abrirVentasSemanaInbi() {
        this.dataTablaSemana = this.vendedorasActuales
        this.tituloSemana = 'Ventas semana'
        this.dialogVendedorasSemana = true
      },

    	async initialize4(){
        this.cargar = true
        try {
          await Promise.all([
            this.getSemanaCicloActualYProximo(),
            this.initialize(),
          ])
          // Efectividad no bloquea la carga principal
          this.tiempoEfectivo()
        } catch (e) {
          console.warn('[VentasMomentoINBI] initialize4:', e)
        } finally {
          this.cargar = false
        }
    	},

      crearGrafica( ){

        let root     = am5.Root.new(this.$refs.chartdiv);

        root.setThemes([
          am5themes_Animated.new(root)
        ]);


        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        let chart = root.container.children.push(am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: "none",
          wheelY: "none",
          paddingLeft: 0
        }));

        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        cursor.lineY.set("visible", false);

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        let xRenderer = am5xy.AxisRendererX.new(root, {
          minGridDistance: 30,
          minorGridEnabled: true
         });

        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
          maxDeviation: 0,
          categoryField: "name",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {})
        }));

        xRenderer.grid.template.set("visible", false);

        let yRenderer = am5xy.AxisRendererY.new(root, {});
        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
          maxDeviation: 0,
          min: 0,
          extraMax: 0.1,
          renderer: yRenderer
        }));

        yRenderer.grid.template.setAll({
          strokeDasharray: [2, 2]
        });

        // Create series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        let series = chart.series.push(am5xy.ColumnSeries.new(root, {
          name: "Series 1",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          sequencedInterpolation: true,
          categoryXField: "name",
          tooltip: am5.Tooltip.new(root, { dy: -25, labelText: "{valueY}" })
        }));


        series.columns.template.setAll({
          cornerRadiusTL: 5,
          cornerRadiusTR: 5,
          strokeOpacity: 0
        });

        series.columns.template.adapters.add("fill", (fill, target) => {
          return chart.get("colors").getIndex(series.columns.indexOf(target));
        });

        series.columns.template.adapters.add("stroke", (stroke, target) => {
          return chart.get("colors").getIndex(series.columns.indexOf(target));
        });

        // Set data
        let data = []
        // [{
        //   name: "24fwfwef",
        //   value: 100,
        //   src: "https://thumbs.dreamstime.com/b/muchacha-sonriente-del-recepcionista-28847483.jpg"
        // }]

        for( const i in this.grafica_data ){

          const { nombre_completo, matriculas_liquidadas } = this.grafica_data[i]

          data.push({
            name: nombre_completo,
            value: matriculas_liquidadas,
            src: "https://thumbs.dreamstime.com/b/muchacha-sonriente-del-recepcionista-28847483.jpg"
          })

        }

        series.bullets.push(function (root, series, dataItem) {
          return am5.Bullet.new(root, {
            locationY: 1,
            sprite: am5.Picture.new(root, {
              width: 50,
              height: 50,
              centerX: am5.p50,
              centerY: am5.p50,
              src: dataItem.dataContext.src // ✅ importante
            })
          });
        });

        // console.log("🖼 Bullet para:", dataItem.dataContext.name, dataItem.dataContext.src);

        xAxis.data.setAll(data);
        series.data.setAll(data);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        console.log( 10 )

        series.appear(1000);
        chart.appear(1000, 100);

        this.root = root
      },

    	initialize () {
        var payload = { fechaini: this.fechaini, escuela: this.escuela, soloEscuela: true }

        return this.$http.post('kpi.ventasmomento', payload ).then(response=>{

          this.restanDias = response.data.diasRestantes

          this.tablaFast        = response.data.vendedorasFast
          this.tablaInbi        = response.data.vendedorasInbi
          this.totalFast        = response.data.totalFast
          this.totalInbi        = response.data.totalInbi

          this.metas            = response.data.metas

        	// caoichovnonvavvv
        	this.encabezados            = response.data.encabezados
        	this.encabezados_ant        = response.data.encabezados
        	this.vendedorasActuales     = response.data.vendedorasActuales
        	this.vendedorasActualesFiltered     = response.data.vendedorasActuales

        	this.vendedorasActualesFAST = response.data.vendedorasActualesFAST
        	this.vendedorasActualesFASTFiltered = response.data.vendedorasActualesFAST
        	this.encabezadosFast        = response.data.encabezadosFast
        	this.encabezados_antFast    = response.data.encabezadosFast

          this.id_ciclo               = response.data.id_ciclo
          this.id_ciclo_relacionado   = response.data.id_ciclo_relacionado
          this.ciclo                  = response.data.ciclo

          this.datosTablaHeaders6 = [
            {
              columna1: 'Nvas. Liq. INBI',
              columna2: ` ${ this.encabezados.matriculas_liquidadasSemAnt}`,
              columna3: ` ${ this.encabezados.matriculas_liquidadas}`,
              columna5: this.encabezados.matriculas_liquidadasSemAnt,
              columna6: this.encabezados.matriculas_liquidadas,
            },
          ]


          if (this.root) {
            this.root.dispose(); // ✅ Importante para evitar memory leaks
          }

          // Cargar planteles; si falla, el catch de getCiclo avisa
          return this.getCiclo()
        }).catch( error =>{
          this.validarError( error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudo cargar ventas al momento' )
        })
      },

      tiempoEfectivo( ){
        // Misma fórmula que Reporte de efectividad (EFECT): primer mensaje + T. Activo del usuario logueado
        const payload = {
          escuela: 1,
          fechaini: this.fechaini,
        }
        const nombreSesion =
          (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.nombre_completo) || 'N/A'

        return axios.post('reporte.efectividad.usuario', payload).then((response) => {
          const data = response.data || {}
          this.tiempoActividad = this.limpiarTiempoActividad(data.tiempo_activo) || 'N/A'
          this.primer_contacto = this.limpiarTiempoActividad(data.primer_contacto) || 'N/A'
          this.nombreEfectividad = nombreSesion
        }).catch((error) => {
          const msg =
            error && error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'No se pudo cargar hora de inicio / tiempo actividad'
          console.warn('[VentasMomentoINBI] tiempoEfectivo:', msg)
          this.tiempoActividad = 'N/A'
          this.primer_contacto = 'N/A'
          this.nombreEfectividad = nombreSesion
        })
      },

      /** Quita 00:00:00 / milisegundos; deja vacío si no hay actividad real. */
      limpiarTiempoActividad(valor) {
        if (valor == null || valor === '' || valor === 'NO HAY REGISTRO') {
          return ''
        }
        const s = String(valor).trim().split('.')[0]
        if (s === '00:00:00' || s === '0:00:00' || s === '00:00') return ''
        // Quitar segundos si son :00 → 01:23:00 → 01:23
        if (/^\d{1,2}:\d{2}:00$/.test(s)) return s.slice(0, -3)
        return s
      },

      async datosDeRI() {

        //console.log('buscar ciclos')
        //console.log( this.ciclo )
        const payload = {"cicloPre":{"id_ciclo":402,"ciclo":"CICLO 11_25","fecha_inicio_ciclo":"2025-11-03 00:00:00","fecha_fin_ciclo":"2025-11-30 00:00:00","comentarios":"","fecha_alta":"2025-01-05 10:44:59","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":334,"fecha_ultimo_cambio":"2025-12-06 11:11:24","ciclo_abierto_sn":1,"id_ciclo_relacionado":403,"activo_ventas":1},"cicloAct":{"id_ciclo":404,"ciclo":"CICLO 12_25","fecha_inicio_ciclo":"2025-12-01 00:00:00","fecha_fin_ciclo":"2026-01-11 00:00:00","comentarios":"","fecha_alta":"2025-01-05 10:44:59","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":334,"fecha_ultimo_cambio":"2025-12-04 09:01:28","ciclo_abierto_sn":1,"id_ciclo_relacionado":405,"activo_ventas":1},"cicloSig":{"id_ciclo":406,"ciclo":"CICLO 01_26","fecha_inicio_ciclo":"2026-01-12 00:00:00","fecha_fin_ciclo":"2026-02-08 00:00:00","comentarios":null,"fecha_alta":"2025-01-05 10:45:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2025-08-19 13:08:37","ciclo_abierto_sn":1,"id_ciclo_relacionado":407,"activo_ventas":1}}

        //console.log( payload )

        await this.$http.post('kpi.cantactual', payload ).then(response=>{
          this.resultadoRi = response.data
          this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi

          //console.log( response.data )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      async getSemanaCicloActualYProximo () {
        try {
          const response = await this.$http.get('kpi.dias.restantes.para.inscribirse')
          this.segundaSemanaCicloActual = response.data.inicio_ciclo_actual
          this.segundoDomingoCicloProximo = response.data.inicio_ciclo_siguiente
        } catch (error) {
          console.log(error)
        }
      },

      sumarDias(fecha, dias) {
        const f = new Date(fecha);         // convertir a Date
        f.setDate(f.getDate() + dias);     // sumar los días
        return f;                          // devuelve un objeto Date
      },

      formatFecha(fecha) {
        if (!fecha) return '';

        const meses = [
          'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
          'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];

        const f = new Date(fecha);
        const dia = f.getDate().toString().padStart(2, '0');
        const mes = meses[f.getMonth()];

        return `${dia} de ${mes}`;
      },

      diasFaltantes(fechaObjetivo) {
        const hoy = new Date();
        const objetivo = new Date(fechaObjetivo);

        const diffMs = objetivo - hoy; // diferencia en milisegundos
        const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return dias;
      },

      getCiclo () {
        if (!this.id_ciclo) {
          console.warn('[VentasMomentoINBI] getCiclo: sin id_ciclo')
          return Promise.resolve()
        }

        return this.$http.get('kpi.inscripciones.total.inbi/' + this.id_ciclo).then(response=>{
            // Misma asignación que VentasMomento.vue (antes Array.isArray dejaba la tabla vacía)
            const raw = response && response.data
            const rows = Array.isArray(raw)
              ? raw
              : (raw && Array.isArray(raw.data) ? raw.data : null)

            if (!rows) {
              console.warn('[VentasMomentoINBI] getCiclo: respuesta inesperada', raw)
              this.dataTablaInbiUno = []
              return
            }

            this.dataTablaInbiUno = rows

            let metaTotalI = 0
            let faltanTotalI = 0
            let hayFastI = 0
            let totalContactos = 0
            let total_completos = 0
            let total_incompletos = 0
            let total_merca = 0
            let total_sucursal = 0

            for( const i in this.dataTablaInbiUno ){

              const { id_plantel, total } = this.dataTablaInbiUno[i]

              switch( id_plantel ){
                case 21: 
                  this.dataTablaInbiUno[i]['meta_money'] = '6050' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(6050) 
                break;
                
                case 25: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3850' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3850) 
                break;
                
                case 1: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3930' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3930) 
                break;
                
                case 10015: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3820' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3820) 
                break;
                
                case 4: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3740' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3740) 
                break;
                
                case 24: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3530' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3530) 
                break;
                
                case 23: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3520' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3520) 
                break;
                
                case 32: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3430' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3430) 
                break;
                
                case 22: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3140' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3140) 
                break;
                
                case 3: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3190' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3190) 
                break;
                
                case 6: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3060' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3060) 
                break;
                
                case 31: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2980' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2980) 
                break;
                
                case 28: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2840' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2840) 
                break;
                
                case 10004: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2870' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2870) 
                break;
                
                case 29: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2640' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2640) 
                break;
                
                case 17: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3660' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(3660) 
                break;
                
                case 5: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2680' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2680) 
                break;
                
                case 27: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2600' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2600) 
                break;
                
                case 2: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2330' 
                  this.dataTablaInbiUno[i]['meta_money_format'] = this.format(2330) 
                break;

              }

              const existeMeta = (this.metas || []).find( el => el.id_plantel == id_plantel )

              let meta = existeMeta ? existeMeta.meta : 0

              metaTotalI += meta
              hayFastI   += total

              let faltan = meta - total
              this.dataTablaInbiUno[i]['faltan'] = faltan
              this.dataTablaInbiUno[i]['meta'] = meta
            }

            // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
            this.dataTablaInbiUno.sort((a, b) => b.total - a.total);

            // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
            this.dataTablaInbiUno.forEach((plantel, index) => {
              plantel.position = index + 1; // La posición comienza en 1
              totalContactos += plantel.totalContactos
              total_completos += plantel.total_completos
              total_incompletos += plantel.total_incompletos
              total_merca += plantel.total_merca
              total_sucursal += plantel.total_sucursal
            });


            var payload = {
              plantel: 'Total',
              total:0,
              total_fuera_ciclo: 0,
              total_completos:0,
              total_incompletos:0,
              total_sucursal: 0,
              total_merca: 0,
              prospectos: [],
              completos: [],
              incompletos: [],
              merca: [],
              sucursal: [],
            }
            for(const i in this.dataTablaInbiUno){

              let total_fuera_ciclo = 0
              if( this.dataTablaInbiUno[i].quienVendio ){
                this.dataTablaInbiUno[i].quienVendio.map( q => {
                  total_fuera_ciclo += +q.total_registros_diferente_ciclo
                })
                this.dataTablaInbiUno[i].total_fuera_ciclo = total_fuera_ciclo
              }

              payload.total += this.dataTablaInbiUno[i].total
              payload.total_fuera_ciclo += +total_fuera_ciclo
              payload.total_completos += this.dataTablaInbiUno[i].total_completos
              payload.total_incompletos += this.dataTablaInbiUno[i].total_incompletos
              payload.total_sucursal += this.dataTablaInbiUno[i].total_sucursal
              payload.total_merca += this.dataTablaInbiUno[i].total_merca
              payload.prospectos.push( ...(this.dataTablaInbiUno[i].prospectos || []) )
              payload.completos.push( ...(this.dataTablaInbiUno[i].completos || []) )
              payload.incompletos.push( ...(this.dataTablaInbiUno[i].incompletos || []) )
              payload.merca.push( ...(this.dataTablaInbiUno[i].merca || []) )
              payload.sucursal.push( ...(this.dataTablaInbiUno[i].sucursal || []) )
            }
            // this.totalInbi =  payload.total
            this.dataTablaInbiUno.push({...payload,
              totalContactos,
              total_completos,
              total_incompletos,
              total_merca,
              total_sucursal,
              faltan: metaTotalI - hayFastI, meta: metaTotalI })
          }).catch(error=>{
            console.log('[VentasMomentoINBI] getCiclo:', error)
            const msg =
              error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo cargar Inscritos Inbi'
            if (typeof this.validarError === 'function') this.validarError(msg)
          })
      },

      verDetalle(prospectos, vendedoras){
        console.log( vendedoras.length )
        this.prospectosInscritos = []
        this.vendedoras = []
        // console.log( prospectos )
        this.prospectosInscritos = prospectos
        this.vendedoras = vendedoras && vendedoras.length ? vendedoras : []
        this.dialogInscritosProspectos = true
      },

      verQuienVendio(vendedoras, item ) {
        this.quienVendio  = []
        this.quienVendio  = vendedoras
        this.itemSucursal = item
        this.dialogQuienVendio = true

        // if( ![1,334].includes( this.getdatosUsuarioERPERP.iderp ) ){
        //   this.quienVendio = this.quienVendio.filter( el => el.id_usuario == this.getdatosUsuarioERPERP.iderp )
        // }

        let total = this.itemSucursal.total

        for( const i in this.quienVendio ){

          const { total_registros } = this.quienVendio[i]

          let porcentaje = ( total_registros / total ) 

          this.quienVendio[i]['porcentaje']     = ( porcentaje * 100 ).toFixed( 2 )

        }
      },

      initialize2() {
        // Abrimos modal de carga
        this.cargar = true
        // Limpiamos los prospectos
        this.prospectos  = []

        return this.$http.get('prospectos.vendedora/' + 2 + '/' + this.getdatosUsuarioERPERP.iderp).then((response) => {
          // Filtramos los que necesitamos, depende si es vendedora o administrador
          this.prospectos = response.data.respuesta

          // Prospectos que se encuentran el inducción o tienen tarea programada que no es para hoy
          this.prospectosAgendadaInduccion  = response.data.prospectosConSeguimiento.concat( response.data.prospectosAgendadaInduccion )

          // Prospectos sin seguimiento hoy y sin tareas programadas
          this.prospectosSeguimiento        = response.data.prospectosSeguimiento

          /*this.cargar = false*/
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      initialize3() {
        const payload = {
        	fecha_inicio: this.fecha_inicio,
        	fecha_final:  this.fecha_final
        }

        // Mandamos a llamar a la api
        this.$http.post('marketing.contactos',payload).then(response=>{

					for( const i in this.vendedorasActuales ){

						const { nombre_completo, id_usuario } = this.vendedorasActuales[i]

						this.vendedorasActuales[i]['atrasados']   = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 1 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['nuevos']      = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['seguimiento'] = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['total'] = this.prospectosSeguimiento.filter((el)=>{ return el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length

						const existe = response.data.dataTabla.find( el => el.usuario_asignado == id_usuario )
						this.vendedorasActuales[i]['contactos'] = existe ? existe[`${this.fecha_inicio}`] : 0

					}

					for( const i in this.vendedorasActualesFAST ){

						const { nombre_completo, id_usuario } = this.vendedorasActualesFAST[i]

						this.vendedorasActualesFAST[i]['atrasados']   = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 1 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['nuevos']      = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['seguimiento'] = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['total'] = this.prospectosSeguimiento.filter((el)=>{ return el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length

						const existe = response.data.dataTabla.find( el => el.usuario_asignado == id_usuario )
						this.vendedorasActualesFAST[i]['contactos'] = existe ? existe[`${this.fecha_inicio}`] : 0

					}

					this.vendedorasActuales     = [...this.vendedorasActuales].sort((a, b) => b.contactos - a.contactos);
					this.vendedorasActualesFAST = [...this.vendedorasActualesFAST].sort((a, b) => b.contactos - a.contactos);

					this.vendedorasActuales.push({
		        nombre_completo: 'TOTAL',
		        atrasados      : this.vendedorasActuales.map(item => item.atrasados).reduce((prev, curr) => prev + curr, 0),
		        nuevos         : this.vendedorasActuales.map(item => item.nuevos).reduce((prev, curr) => prev + curr, 0),
		        seguimiento    : this.vendedorasActuales.map(item => item.seguimiento).reduce((prev, curr) => prev + curr, 0),
		        total          : this.vendedorasActuales.map(item => item.total).reduce((prev, curr) => prev + curr, 0),
		        contactos      : this.vendedorasActuales.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0),
		        escuela        : 1,
		        matriculas_liquidadas: this.vendedorasActuales.map(item => item.matriculas_liquidadas).reduce((prev, curr) => prev + curr, 0),
		      })

		      this.vendedorasActualesFAST.push({
		        nombre_completo: 'TOTAL',
		        atrasados      : this.vendedorasActualesFAST.map(item => item.atrasados).reduce((prev, curr) => prev + curr, 0),
		        nuevos         : this.vendedorasActualesFAST.map(item => item.nuevos).reduce((prev, curr) => prev + curr, 0),
		        seguimiento    : this.vendedorasActualesFAST.map(item => item.seguimiento).reduce((prev, curr) => prev + curr, 0),
		        total          : this.vendedorasActualesFAST.map(item => item.total).reduce((prev, curr) => prev + curr, 0),
		        contactos      : this.vendedorasActualesFAST.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0),
		        escuela        : 2,
		        matriculas_liquidadas: this.vendedorasActualesFAST.map(item => item.matriculas_liquidadas).reduce((prev, curr) => prev + curr, 0),
		      })

					this.reporteFast = this.vendedorasActualesFAST.filter( el => el.escuela == 2 )
					this.reporteInbi = this.vendedorasActuales.filter( el => el.escuela == 1 )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      riSucursales () {

        this.miniReporte = []

        this.cargar = true
        const payload = {
          cicloPre:  {
            ciclo: "CICLO 10_24",
            fecha_fin_ciclo: "2024-10-07 00:00:00",
            fecha_inicio_ciclo: "2024-11-13 00:00:00",
            id_ciclo: 338,
            id_ciclo_relacionado: 337,
          },
          cicloAct:  {
            ciclo: "CICLO 11_24",
            fecha_fin_ciclo: "2024-12-01 00:00:00",
            fecha_inicio_ciclo: "2024-11-04 00:00:00",
            id_ciclo: 340,
            id_ciclo_relacionado: 339,
          },
          cicloSig:  {
            ciclo: "CICLO 12_24",
            fecha_fin_ciclo: "2025-01-12 00:00:00",
            fecha_inicio_ciclo: "2024-12-02 00:00:00",
            id_ciclo: 342,
            id_ciclo_relacionado: 341,
          },
        }
        return this.$http.post('kpi.cantactual', payload ).then(response=>{

          let fastRI = response.data.riPlantelesFast.find( el => el.plantel == 'TOTAL')
          let inbiRI = response.data.riPlantelesInbi.find( el => el.plantel == 'TOTAL')

          let fastMenor = response.data.riPlantelesFast.filter( el => el.reinscribibles > 0 ).sort((a, b) => a.porcentajeAvance - b.porcentajeAvance)

          let inbiMenor = response.data.riPlantelesInbi.filter( el => el.reinscribibles > 0 ).sort((a, b) => a.porcentajeAvance - b.porcentajeAvance)

          this.miniReporte.push({
            escuela: 'FAST',
            ritotal: '%' + fastRI.porcentajeAvance,
            risucursal: fastMenor[0].plantel + ' ( %' + fastMenor[0].porcentajeAvance + ')',
            dif: 0,
            sucursalni:'',
            monto1: this.totalFast + ' de ' + 145
          })

          this.miniReporte.push({
            escuela: 'INBI',
            ritotal: '%' + inbiRI.porcentajeAvance,
            risucursal: inbiMenor[0].plantel + ' ( %' + inbiMenor[0].porcentajeAvance + ')',
            dif: 0,
            sucursalni:'',
            monto1: this.totalInbi + ' de ' + 401
          })

          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      riSucursalesMonto () {
        this.cargar = true
        const payload = {
          cicloPre:  {
            ciclo: "CICLO 10_24",
            fecha_fin_ciclo: "2024-10-07 00:00:00",
            fecha_inicio_ciclo: "2024-11-13 00:00:00",
            id_ciclo: 338,
            id_ciclo_relacionado: 337,
          },
          cicloAct:  {
            ciclo: "CICLO 11_24",
            fecha_fin_ciclo: "2024-12-01 00:00:00",
            fecha_inicio_ciclo: "2024-11-04 00:00:00",
            id_ciclo: 340,
            id_ciclo_relacionado: 339,
          },
          cicloSig:  {
            ciclo: "CICLO 12_24",
            fecha_fin_ciclo: "2025-01-12 00:00:00",
            fecha_inicio_ciclo: "2024-12-02 00:00:00",
            id_ciclo: 342,
            id_ciclo_relacionado: 341,
          },
          iderp: 334,
          idpuesto : 11
        }
        return this.$http.post('kpi.cantactual.montos', payload ).then(response=>{

          let fastMenor = response.data.riPlantelesFast.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.diferencia - b.diferencia)

          let inbiMenor = response.data.riPlantelesInbi.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.diferencia - b.diferencia)

          this.miniReporte[0].dif = fastMenor[0].plantel
          this.miniReporte[1].dif = inbiMenor[0].plantel


          let fastMenor2 = response.data.riPlantelesFast.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.niActual - b.niActual)

          let inbiMenor2 = response.data.riPlantelesInbi.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.niActual - b.niActual)
          this.miniReporte[0].sucursalni = fastMenor2[0].plantel + ' ( ' + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( fastMenor2[0].niActual ) + ' ) '
          this.miniReporte[1].sucursalni = inbiMenor2[0].plantel + ' ( ' + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( inbiMenor2[0].niActual ) + ' ) '

          this.cargar = false

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      abrirDialog( value ){
        this.alumnos = value
        this.dialogAlumnos = true
      },

      exportar(){
        this.exportarData()
      },

      s2ab2(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      format( valor ){
        const n = Number(valor)
        if (!Number.isFinite(n)) {
          return Number(0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        }
        return n.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        });
      },

      calcularConvencimiento(inscritos, totalContactos) {
        if (!totalContactos || totalContactos === 0) return 0;
        const porcentaje = (inscritos / totalContactos) * 100;
        return porcentaje.toFixed(2); // dos decimales
      },

      traducirEstado(valor) {
        const estados = {
          0: 'Sin plantel',
          1: 'Monterrey',
          2: 'CDMX',
          3: 'GDL',
          4: 'FAST'
        };
        return estados[valor] || '';
      },

      calcularTotal(data) {
        const total = {
          id_usuario: 'Total',  // O un valor fijo como "Total"
          nombre_completo: 'Total',  // Nombre o campo estático para el total
          escuela: '',
          estado: '',
          matriculas_liquidadas: 0,  // Solo calcularemos la suma de este campo
        };

        // Sumar los valores de "matriculas_liquidadas"
        data.forEach(item => {
          total.matriculas_liquidadas += item.matriculas_liquidadas;
        });

        return total;  // Regresa el objeto "Total"
      },

      onCiudadChangeVentasCicloVendedora(){
        const r = this.traducirEstado( this.inbiFilter )
        if( this.tablaVentaCicloInbi ) this.tablaVentasCiclo = this.tablaInbi
        else this.tablaVentasCiclo = this.tablaFast
        if(r) this.tablaVentasCiclo = this.tablaVentasCiclo.filter( t => t.estado === r)
      },

      onCiudadChangeRI(){

        this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi

        if( this.inbiFilter )
        this.resultadoRiFiltro =
        this.resultadoRiFiltro.filter( t => +t.estado === this.inbiFilter)

      }

    },
  }
</script>

<style scoped>
.hello {
  width: 100%;
  height: 500px;
}
</style>
